export default __webpack_public_path__ + "static/media/036-watering can.4217c98a.svg";